import { ColumnFiltersState } from '@tanstack/react-table';
import { atom } from 'jotai';

export const flatColumnFiltersAtom = atom<ColumnFiltersState | null>(null);
